import { component, computed, observable } from 'knockout-decorators'

import { ShippingMode } from '@tixa/schema'
import type { Offer } from '@tixa/schema'
import { Language } from '~/utils'

import source from './template.html?raw'

import { CartState } from '../state'

@component('cart-shipping', source)
export class CartShipping {
  private cartState: CartState = CartState.get()

  @observable selectedShippingSku = ''

  @computed get shippingOffers(): [Offer, unknown][] {
    return this.cartState.shippingOffers.map((offer) => {
      const mappedOffer = {
        formattedPrice: Language.formatCurrency(
          offer.price,
          offer.priceCurrency
        ),
      }
      Object.defineProperty(mappedOffer, 'checkedSku', {
        get: () => this.selectedShippingSku,
        set: (value) => {
          this.selectedShippingSku = value
          this.cartState.selectedShippingSku = value
          this.cartState.shippingMode = ShippingMode.ship
        },
      })
      return [offer, mappedOffer]
    })
  }

  @computed get hasShipping(): boolean {
    return this.shippingOffers.length > 0
  }

  @computed get shippingPrice(): string {
    if (!this.hasShipping) {
      return ''
    }

    const [offer] = this.shippingOffers[0]
    return Language.formatCurrency(offer.price, offer.priceCurrency)
  }

  @computed get radioValue() {
    return this.cartState.shippingMode
  }
  set radioValue(value: ShippingMode) {
    this.selectedShippingSku = ''
    this.cartState.selectedShippingSku = value
    this.cartState.shippingMode = ShippingMode.eticket
  }

  @computed get isShipping() {
    return this.cartState.shippingMode === ShippingMode.ship
  }

  @computed get isEticket() {
    return this.cartState.shippingMode === ShippingMode.eticket
  }
}
